/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ plan: NonNullable<unknown> }} Common_Pricing_Payment_For_PlanInputs */

const en_common_pricing_payment_for_plan = /** @type {(inputs: Common_Pricing_Payment_For_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.plan}`)
};

const zh_common_pricing_payment_for_plan = /** @type {(inputs: Common_Pricing_Payment_For_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.plan}`)
};

/**
* | output |
* | --- |
* | "{plan}" |
*
* @param {Common_Pricing_Payment_For_PlanInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_pricing_payment_for_plan = /** @type {((inputs: Common_Pricing_Payment_For_PlanInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Pricing_Payment_For_PlanInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_pricing_payment_for_plan(inputs)
	return zh_common_pricing_payment_for_plan(inputs)
});
export { common_pricing_payment_for_plan as "common.pricing.payment_for_plan" }